import { CheckboxField } from 'form';
import { useTranslation } from 'i18n';
import { SectionContainer, Typography } from 'ui';

export const ClearOverridesSection = () => {
  const { t } = useTranslation('orders');

  return (
    <SectionContainer columns={1} title={t('shipmentClearOverridesSection.title')}>
      <Typography>{t('shipmentClearOverridesSection.description')}</Typography>
      <CheckboxField
        label={t('shipmentClearOverridesSection.labels.clearLoadsOverrides')}
        name="clear_loads_overrides"
      />
    </SectionContainer>
  );
};
